module.exports = __webpack_public_path__ + "static/media/EthanHubbartt.13a2dbe4.jpg";